// This is the entry point for the home component
import React, { FC, useCallback, useContext, useEffect } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Styling
import injectSheet from 'react-jss';

// Actions

// Components
import CheckBox from 'Components/CheckBox';

import { ProductAnalyticsContext } from 'Context/ProductAnalytics';

import { areEqualObjects } from 'Utils/areEqual';
import withErrorBoundary from 'HOC/ErrorBoundary';
import { setEthnicityValue } from './actions/ethnicity.actions';
import styleSheet from './styles';

interface Props {
  classes: any;
  selectAllEthnicity: any;
}

const Ethnicity: FC<Props> = ({ classes, selectAllEthnicity }: Props) => {
  const selector = useSelector(
    (selectors: any) => selectors.filter.demographics.ethnicity,
    areEqualObjects
  );
  const dispatch = useDispatch();

  const {
    actions: { filterTrack },
  } = useContext(ProductAnalyticsContext);

  // Will be needed for future use.
  const {
    americanIndianOrAlaskaNative,
    asian,
    blackOrAfricanAmerican,
    hispanicOrLatin,
    nativeHawaiianOrOtherPacificIslander,
    white,
    mixedRace,
    other,
  } = selector;

  const callback = (e: any) => {
    const { id } = e.target;

    // Combined Analytics Event
    filterTrack({
      filterCategory: 'Demographics',
      filterName: 'Ethnicity',
      filterValue: id,
      addToStore: true,
    });
    setEthnicityValue(dispatch, selector[id], id);
  };

  useEffect(() => {
    // The intial value will be undefined.  It will only be set to true or false, when
    // either the SelectAll or Clear button are clicked.
    if (selectAllEthnicity !== undefined) {
      // Send events for each checkbox.
      filterTrack({
        filterCategory: 'Demographics',
        filterName: 'Ethnicity.All',
        filterValue: selectAllEthnicity,
        addToStore: selectAllEthnicity,
      });
    }
  }, [selectAllEthnicity]);

  return (
    <div className={classes.container}>
      <CheckBox
        label="American Indian or Alaska Native"
        id="americanIndianOrAlaskaNative"
        value={americanIndianOrAlaskaNative}
        isChecked={americanIndianOrAlaskaNative}
        onClick={useCallback(callback, [americanIndianOrAlaskaNative])}
        overrideStyles={{ margin: '8px 0 17px' }}
      />
      <CheckBox
        label="Asian"
        id="asian"
        value={asian}
        isChecked={asian}
        onClick={useCallback(callback, [asian])}
        overrideStyles={{ margin: '0 0 17px' }}
      />
      <CheckBox
        label="Black or African American"
        id="blackOrAfricanAmerican"
        value={blackOrAfricanAmerican}
        isChecked={blackOrAfricanAmerican}
        onClick={useCallback(callback, [blackOrAfricanAmerican])}
        overrideStyles={{ margin: '0 0 17px' }}
      />
      <CheckBox
        label="Hispanic or Latin"
        id="hispanicOrLatin"
        value={hispanicOrLatin}
        isChecked={hispanicOrLatin}
        onClick={useCallback(callback, [hispanicOrLatin])}
        overrideStyles={{ margin: '0 0 17px' }}
      />
      <CheckBox
        label="Native Hawaiian or Other Pacific Islander"
        id="nativeHawaiianOrOtherPacificIslander"
        value={nativeHawaiianOrOtherPacificIslander}
        isChecked={nativeHawaiianOrOtherPacificIslander}
        onClick={useCallback(callback, [nativeHawaiianOrOtherPacificIslander])}
        overrideStyles={{ margin: '0 0 17px' }}
      />
      <CheckBox
        label="White"
        id="white"
        value={white}
        isChecked={white}
        onClick={useCallback(callback, [white])}
        overrideStyles={{ margin: '0 0 17px' }}
      />
      <CheckBox
        label="Mixed Race"
        id="mixedRace"
        value={mixedRace}
        isChecked={mixedRace}
        onClick={useCallback(callback, [mixedRace])}
        overrideStyles={{ margin: '0 0 17px' }}
      />
      <CheckBox
        label="Other"
        id="other"
        value={other}
        isChecked={other}
        onClick={useCallback(callback, [other])}
        overrideStyles={{ margin: '0 0 8px' }}
      />
    </div>
  );
};

export default withErrorBoundary(injectSheet(styleSheet)(Ethnicity));
